export function buildMonthStartFilter(monthStart: string): string {
  return `MonthStarts/MonthStart+eq+datetime${encodeURIComponent(`'${monthStart}T00:00:00'`)}`;
}

export function isMonthlyAttendanceReport(serverURL: string): boolean {
  return serverURL.toLowerCase().includes("monthlycert_5_2");
}

export function isSupplementalReport(report: { name: string }): boolean {
  return report.name.toLowerCase().includes("supplemental");
}
